import { NEW_ORDER_SIGNAL_KEY_PREFIX } from 'src/constants/key_constants';

/**
 * Records that the order with the given id was just created, so the edit page
 * can treat the first load as a "new order" (skip eager validation, skip
 * discard confirmation, etc.).
 *
 * Call this in the CREATE action immediately before `throw redirect(...)`.
 * The signal is keyed by order id so concurrent tabs don't interfere.
 */
export const signalNewOrder = (orderId: string): void => {
  sessionStorage.setItem(`${NEW_ORDER_SIGNAL_KEY_PREFIX}${orderId}`, '1');
};
